import {tap} from 'rxjs/operators';

import ajax from 'iss/utils/ajax';

export const systemStatusNotifications = ajax.cache("/system-status", 5 * ajax.MINUTES);

export function modifyNotification(subsystem, notification) {
  return ajax.putJson("/system-status/"+subsystem, notification, {resultType: 'text'})
    .pipe(tap(systemStatusNotifications.clearCache));
}

export function removeNotification(subsystem) {
  return ajax.deleteJson("/system-status/"+subsystem, null, {resultType: 'text'})
    .pipe(tap(systemStatusNotifications.clearCache));
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/SystemStatusNotificationService.js